import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App, syncSystemThemeWithBrandOverrides } from './App.js';
import './index.css';

syncSystemThemeWithBrandOverrides();

const rootEl = document.getElementById('root');
if (rootEl !== null) {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
